import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "className", "disabled"];
import React from 'react';
import { Card } from 'semantic-ui-react';
import Content from './components/Content';
import Image from './components/Image';
import ImageCarousel from './components/ImageCarousel';
import { classNames } from '../../../../utils/classname';
import useSemanticUiProps from '../../../foundation/hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../foundation/types/component';
import './ImageCard.css';
var defaultProps = {
  children: null,
  content: null,
  className: '',
  disabled: false
};
export default function ImageCard(_ref) {
  var _classNames;
  var children = _ref.children,
    content = _ref.content,
    className = _ref.className,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getCardProps = _useSemanticUiProps.getCardProps;
  var cardProps = getCardProps(rest);
  var finalContent = content || children;
  var finalClassName = classNames((_classNames = {
    'image-card': true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "disabled", disabled), _classNames));
  return /*#__PURE__*/React.createElement(Card, _extends({
    className: finalClassName
  }, cardProps), finalContent);
}
ImageCard.defaultProps = defaultProps;
ImageCard.Image = Image;
ImageCard.ImageCarousel = ImageCarousel;
ImageCard.Content = Content;